__turbopack_context__.v({
  "clearIndicator": "select-module-scss-module__zkgN9G__clearIndicator",
  "controlContent": "select-module-scss-module__zkgN9G__controlContent",
  "countWithError": "select-module-scss-module__zkgN9G__countWithError",
  "countryFlagMultiValue": "select-module-scss-module__zkgN9G__countryFlagMultiValue",
  "countryFlagOption": "select-module-scss-module__zkgN9G__countryFlagOption",
  "countryFlagSingleValue": "select-module-scss-module__zkgN9G__countryFlagSingleValue",
  "dropdownIndicator": "select-module-scss-module__zkgN9G__dropdownIndicator",
  "hiddenValuesCount": "select-module-scss-module__zkgN9G__hiddenValuesCount",
  "multiValue": "select-module-scss-module__zkgN9G__multiValue",
  "multiValueContainer": "select-module-scss-module__zkgN9G__multiValueContainer",
  "multiValueContainerNoWrap": "select-module-scss-module__zkgN9G__multiValueContainerNoWrap",
  "multiValueIsNotValid": "select-module-scss-module__zkgN9G__multiValueIsNotValid",
  "multiValueIsVisible": "select-module-scss-module__zkgN9G__multiValueIsVisible",
  "multiValueRemoveIcon": "select-module-scss-module__zkgN9G__multiValueRemoveIcon",
  "multiValueRemoveIconWrapper": "select-module-scss-module__zkgN9G__multiValueRemoveIconWrapper",
  "multiValueWithValidationTooltip": "select-module-scss-module__zkgN9G__multiValueWithValidationTooltip",
  "placeholder": "select-module-scss-module__zkgN9G__placeholder",
  "selectEncapsulation": "select-module-scss-module__zkgN9G__selectEncapsulation",
  "selectPortalEncapsulation": "select-module-scss-module__zkgN9G__selectPortalEncapsulation",
  "selectSpinner": "select-module-scss-module__zkgN9G__selectSpinner",
  "treeSelectMenu": "select-module-scss-module__zkgN9G__treeSelectMenu",
});
